export default "__VITE_ASSET__DC6atwT8__";